import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import Edges from './Edges';
import { appServices } from '../services';
import { useStore } from '../store';
import logo from '../images/Timetable_logo_green.svg';
import * as theme from '../theme';

const Header = () => {
    const [
        {
            appState: { schools }
        },
        dispatch
    ] = useStore() as any;

    const loadSchools = async () => {
        await appServices.getSchoolsAndTerms({}, dispatch);
    };

    useEffect(() => {
        if (!schools) {
            loadSchools();
        }
    }, [schools]);

    return (
        <>
            <Container>
                <StyledEdges size='md'>
                    <StyledLink to='/'>
                        <img src={logo} alt='Timetabling Logo' />
                    </StyledLink>
                    <HeadlineLink to='/'>
                        <Headline children='BCIT Timetables' />
                    </HeadlineLink>
                </StyledEdges>
            </Container>
        </>
    );
};

const StyledEdges = styled(Edges)`
    position: relative;
    display: flex;
    align-items: center;

    @media (min-width: 640px) {
        align-items: center;
        padding-top: 0;
    }
`;

const StyledLink = styled(Link)`
    display: flex;
    align-items: center;
    width: 50px;
    height: 40px;
    margin-right: 10px;
    @media (min-width: 640px) {
        margin-right: 20px;
    }
    img {
        max-width: 70%;
        margin: 0;
        @media (min-width: 640px) {
            max-width: 80%;
    }
    }
`;
const HeadlineLink = styled(Link)`
    text-decoration: none;
`;
const Headline = styled.h1`
    color: ${theme.colors.main};
    display: inherit;
    font-size: 1.3em;
    @media (min-width: 640px) {
        display: block;
        margin: 0;
        font-size: 1.3em;
    }
`;

const BannerContainer = styled.div`
    width: 100%;
    /* width: calc(100% - 70px); */
    @media (min-width: 640px) {
        display: none;
    }
`;

const Container = styled.div`
    position: relative;
    overflow: hidden;
    padding: 10px;
    background: #ffffff;
    box-shadow: 0 5px 10px 1px rgba(0, 0, 0, 0.05);
    z-index: 100;
    display:flex;

    @media (min-width: 640px) {
        padding: 20px;
    }
`;

export default Header;
